import axios from "axios";

const PREFIJO = "/api/TpDcmtFrm/"

export const snMessage = {
    params: {
        showMessage: false
    }
}


export default {
    validacionDocumento(formulario){
        const dto = {
            dt1: formulario.ci,  //numero documento
            dt2: formulario.tipoDocumento,  //tipo documento
            dt3: formulario.tipoPersona,  //tipo persona
            dt4: process.env.VUE_APP_PAIS_NAME, //pais
        }
        return axios.post(`${PREFIJO}VmVlDcDnt`,dto, snMessage);
    }
}